import { render } from "./employee-invites.vue?vue&type=template&id=591c8650&scoped=true"
import script from "./employee-invites.vue?vue&type=script&lang=js"
export * from "./employee-invites.vue?vue&type=script&lang=js"

import "./employee-invites.vue?vue&type=style&index=0&id=591c8650&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591c8650"]])

export default __exports__